module.exports = __webpack_public_path__ + "static/media/home_logo.136f193a.png";